import "@fortawesome/fontawesome-free/css/all.css";
import { Chart, registerables } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';
import DataTable from 'datatables.net-bs4/js/dataTables.bootstrap4.mjs';
import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.css';
import 'datatables.net-buttons-bs4/js/buttons.bootstrap4.mjs';
import 'datatables.net-buttons/js/buttons.colVis.mjs';
import 'datatables.net-buttons/js/buttons.html5.mjs';
import 'datatables.net-buttons/js/buttons.print.mjs';
import 'datatables.net-responsive-bs4/css/responsive.bootstrap4.css';
import 'datatables.net-responsive-bs4/js/responsive.bootstrap4.mjs';
import jQuery from 'jquery';
import JSZip from 'jszip';
import pdfMake from 'pdfmake';
import toastr from 'toastr';

Chart.register(annotationPlugin, ...registerables);

window.Chart = Chart;
window.DataTable = DataTable;
window.jQuery = jQuery;
window.$ = jQuery;
window.JSZip = JSZip;
window.pdfMake = pdfMake;
window.toastr = toastr;
